var map = {
	"./albums.png": 110,
	"./beatz.png": 111,
	"./chat.png": 112,
	"./events.png": 113,
	"./followers.png": 114,
	"./media.png": 115,
	"./mix.png": 116,
	"./movies.png": 117,
	"./mp3.png": 118,
	"./news.png": 119,
	"./videos.png": 120
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 109;